import React, { useCallback, useState } from 'react';
import { FlexRow, Text, FlexCell } from '@epam/promo';
import { getFormatedText } from 'hooks/helpers/common';
import { Tag } from 'components/common/Tag';
import { useTaskGroupsStore } from 'store/task-groups';
import { TaskGroupsForm } from '../TaskGroupsForm';
import { TaskGroupsItemProps } from './TaskGroupsItem.model';
import css from './TaskGroupsItem.module.scss';

export const TaskGroupsItem = ({ item }: TaskGroupsItemProps) => {
  const [isFormShown, setIsFormShown] = useState(true);
  const { name, question } = item;

  const { selectedTaskGroup } = useTaskGroupsStore((state) => state);

  const handleClose = useCallback(() => {
    setIsFormShown(false);
  }, []);

  return isFormShown && selectedTaskGroup?.name === item.name ? (
    <div className={css.formContainer}>
      <TaskGroupsForm onClose={handleClose} />
    </div>
  ) : (
    <div className={css.container}>
      <div className={css.item} data-testid="group-list-item">
        <FlexRow cx={css.header}>
          <Tag tooltip="Amount of tasks" value={String(item.tasks?.length)} />
          <FlexCell width="auto">
            <Text cx={`${css.text} ${css.title}`}>
              <b>{getFormatedText(name)}</b>
            </Text>
            {question && <Text cx={css.text}>{getFormatedText(question)}</Text>}
          </FlexCell>
        </FlexRow>
      </div>
    </div>
  );
};
